import * as Sentry from "@sentry/react"
import { env } from "./env"

export const initSentry = () => {
    Sentry.init({
        dsn: "https://b8f951a5e752c00c63a2a3715e7bd04c@o4510397521330176.ingest.de.sentry.io/4510397523492944",
        environment: env.theme, // Tag events with the current site (gea, gecontur, geabrasil)
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Tracing
        tracesSampleRate: 1.0, // Capture 100% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when an error occurs.
    })
}
